import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Slides from '@ifeng/ui_pc_slides';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import { isIE78 } from '../../../../utils/utils';

import styles from './index.css';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    sliderTmpl = item => {
        return (
            <div className={styles.big_pic}>
                <a href={item.url} className={styles.pic_img} target="_blank" data-nomask>
                    <img src={item.thumbnail} className={styles.trans} />
                </a>
                <div className={styles.text} />
                <p className={styles.title}>
                    <a href={item.url} target="_blank" data-innermask>
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    render() {
        const {
            content: {
                newsSlide0,
                newsSlide1,
                newsSlide2,
                newsSlide3,
                newsSlide4,
                newsSlide5,
                newsSlide6,
                newsSlide7,
                newsSlide8,
                hotTitle,
                hotNews1,
                hotNews2,
                hotNews3,
                shopInHotNews1,
                shopInHotNews2,
            },
        } = this.props;

        const newsSlide = [
            ...newsSlide0,
            ...newsSlide1,
            ...newsSlide2,
            ...newsSlide3,
            ...newsSlide4,
            ...newsSlide5,
            ...newsSlide6,
            ...newsSlide7,
            ...newsSlide8,
        ];

        const config = {
            dots: true,
            dotsAction: 'hover',
            autoplayInterval: 5000,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div className={styles.left_box}>
                <div className={`${styles.slide_box} ${isIE78() ? styles.slide : styles.slide_2x}`}>
                    <Slides content={newsSlide} config={config} />
                </div>
                <div className={styles.hot_box}>
                    <Chip id="170169" type="struct" title="热点标题" groupName="热点区" content={hotTitle}>
                        <NewsTitle size="middle" />
                    </Chip>
                    <Chip
                        id="285553"
                        type="recommend"
                        title="热点列表1"
                        groupName="热点区"
                        content={hotNews1}
                        translate="handleNewsData">
                        <NewsList hasTitle isBig size="long" />
                    </Chip>
                    <Chip
                        id="285554"
                        type="recommend"
                        title="热点电商1"
                        groupName="热点区"
                        content={shopInHotNews1}
                        translate="handleNewsData">
                        <NewsList size="long" />
                    </Chip>
                    <Chip
                        id="285557"
                        type="recommend"
                        title="热点列表2"
                        groupName="热点区"
                        content={hotNews2}
                        translate="handleNewsData">
                        <NewsList size="long" />
                    </Chip>
                    <Chip
                        id="285559"
                        type="recommend"
                        title="热点电商2"
                        groupName="热点区"
                        content={shopInHotNews2}
                        translate="handleNewsData">
                        <NewsList size="long" />
                    </Chip>
                    <Chip
                        id="285558"
                        type="recommend"
                        title="热点列表3"
                        groupName="热点区"
                        content={hotNews3}
                        translate="handleNewsData">
                        <NewsList size="long" />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
